import {Component, OnInit, ViewChild} from '@angular/core';
import {LocalStorageService} from 'ng2-webstorage';
import {MessageService} from 'primeng/components/common/messageservice';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';
import {NgForm} from '@angular/forms';
import {ApprovalClassModel} from '../../../../../components/googleClassroom/googleClassroom.model';
import {AddStudentRcModel, rciModel} from '../../../../../components/dataAnalytics/dataAnalytics.model';
import {Router} from '@angular/router';
import {NoticeboardService} from '../../../../../components/noticeboard/noticeboard/noticeboard.service';
import {AppConstants} from '../../../../../app.constants';
import * as html2pdf from "html2pdf.js"
import { DaterangepickerConfig } from 'ng2-daterangepicker';





@Component({
  selector: 'my-notes',
  templateUrl: './my-notes.component.html',
  styleUrls: ['./my-notes.component.css']
})

export class MyNotesComponent implements OnInit {
  @ViewChild('form') form : NgForm;
  selectedFile: File;
  selectStyle: string;
  public previwbtn: boolean = true;
  public printbtn: boolean = false;
  approvalClassModel = new ApprovalClassModel();
  addStudentRcModel = new AddStudentRcModel();
  rcimodel = new rciModel()
  // public data1: AddStudentRcModel[];
  public ReportsData: any = [];
  googleUser: any;
  studentList = [];
  courseId: any;
  selectedGrade: any;
  selectedSection: any = [];
  sectionList: any = [];
  public newSectionArray = [];
  studentData: any = [];
  studentRCData: any = [];
  sumamryTable: any = [];
  public userdetailes = [];
  confirmFlag: boolean = true;
  thresholdText: number;
  selectedGCl: any;
  gclList: any;
  selectedDate: any;
  searchFlag: boolean = false;
  studentThresholdList: any = [];
  standardId: any = [];
  nameofstd: any = [];
  nameofsec: any = [];
  yearIdFrom: any = [];
  yearName: any = [];
  yearnameFrom: any = [];
  yearIdTo: any = [];
  yearnameTo: any = [];
  nameofstudent: any = [];
  nameofsem: any = [];
  nameoftest: any = [];
  loading = "none"
  ChildTestMappingId: string;
  students: any = [];
  SemesterData: any = [];
  YearData: any = [];
  TestData: any = [];
  SchoolDetailsaddress : any =[];
  NumberOfStudents: any = [];
  studentId: any = [];
  testId: any = [];
  sectionId: any = []
  guru: any = [];
  payload: any = [];
  public isEditable : Boolean = true;
  Marks: any = [];
  MaxMarks: any = [];
  today = new Date();
  Averages: any;
  schoolName :any;

  subjectsList: any = [];
  selectedSubject: any;
  selectedYearFrom: any;
  selectedYearTo: any;
  selectedSemester: any;
  selectedTest: any;

  public isSuccessful: number = 0;
  public successOrErrorMsg: string = "";

  public grade: any = [];
  public selectedgrade:  any;
  public selectedsection:  any;

  public CurrentChild: any;
  public schoolLogo1 :string;
  public imgUrl1: string;
  public adminUserFlag: boolean;
  public schoolUserFlag: boolean;
  public mappedData: any;
  public attachment;
  public Address: any;
  public City : any;
  public Pincode : any;
  public PrimaryPhonenumber : any;
  public WebsiteLink : any;
  public Email : any;
  public Logo : any;
  public RegNo :any;
  public userId :string;
  public childMapId : any = [];
  public TeacherNames : any = [];
  public EncodedLogo : any;
  public ShowLevelData: any;
  public selectedlevel: any;


  public papersList: any = [];
  public syllabusList: any = [];
  public agg_question_list: any = [];
  public agg_syllabus_list: any = [];
  public generatedQuestions: any = [];
  public mcqQuestions: any = [];
  public contextQuestions: any = [];
  public mcqQuestionsS: any = [];
  public contextQuestionsS: any = [];

  questionCounts = [5, 10, 15, 20];
  selectedQuestionCount: number;

  mcq: boolean = false;
  discussion: boolean = false;
  shortAnswer: boolean = false;

  isLoading: boolean = false;

  useSyllabus: boolean = true;



  showSaveDialog = false;
  pdfName = '';

  public contextQ: any = [];
  public mcqQ: any = [];
  errorMessage: string = '';
  displayErrorDialog: boolean = false;

  //https://www.npmjs.com/package/ng2-daterangepicker/v/2.0.12

  constructor(private dataAnalyticsService: DataAnalyticsService, private router: Router, private noticeboardService: NoticeboardService, private appConstants: AppConstants, private localStorage: LocalStorageService, private messageService: MessageService, private daterangepickerOptions: DaterangepickerConfig) {
    this.daterangepickerOptions.settings = {
      locale: { format: 'YYYY-MM-DD' },
      alwaysShowCalendars: false
    };
    // this.schoolName = this.localStorage.retrieve('schoolname');
    this.schoolLogo1 = this.localStorage.retrieve('Logo');
    this.imgUrl1 = this.appConstants.fileDownloadUrl;
    // this.attachment = this.imgUrl1 + this.Logo;
    this.userId = this.localStorage.retrieve('id');


  }

  ngOnInit() {
    this.getLevelsName();
    this.getYearData();
    //----------------------------------
    this.adminUserFlag = this.localStorage.retrieve('IsSchoolAdminUser');
    this.schoolUserFlag = this.localStorage.retrieve('Isschooluser');
    this.selectedQuestionCount = this.questionCounts[0];
  }

  getSubjects(){
    this.dataAnalyticsService.getSubjects(this.selectedSection.SectionId).finally(() => { }).subscribe(
      response => {
        let res: any = response;
        console.log("getSubjects", res);
        this.subjectsList = res.subsemList[0];
        try {
          this.selectedSubject = this.subjectsList[0];
        } catch (error) {

        }
      },
      error => {
        console.log("getSubjects error", error);
        this.subjectsList = [];
      });
  }



  toggleSelection() {
    this.useSyllabus = !this.useSyllabus;
    console.log(this.useSyllabus);
    if (this.useSyllabus){
      this.getSyllabusData();

    }else{
      this.getPaperData();
    }
  }



  onSelectedSubject(subject){
    this.papersList = [];
    this.syllabusList = [];
    this.agg_syllabus_list = [];
    this.agg_question_list = [];
    console.log("onSelectedSubject", subject);
  }


  // manage-user data
  public get_userdetailes() {
    var id = this.localStorage.retrieve('Id');
    this.noticeboardService.getUserdetailbyId(id).subscribe(response => {
      this.userdetailes = response['selectedSbAccessPermission'];
      const isAdmin = this.userdetailes.some(u => u.Rank == 1);

      let result = this.mappedData.filter(m =>
        this.userdetailes.some(u => u.standardid === m.standardId && (u.Rank == 2 || u.Rank == 3)
        ));
      const sectionsResult = this.mappedData.filter(m => (
        this.userdetailes.some(u => !result.some(r => r.standardId === u.standardid) && u.Rank == 4 && m.Sections.some(s => s.SectionId === u.sectionid))
      )).map(m => ({
        ...m,
        Sections: m.Sections.filter(s => this.userdetailes.some(u => u.sectionid === s.SectionId))
      }));
      result = result.concat(sectionsResult);
      this.newSectionArray = result;
      console.log(result, 'result');
    })
  }


  private getLevelClassSection(lid) {
    this.dataAnalyticsService.GetLevelStandardSectionMapping(lid).finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        console.log("mappedData", mappedData);
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (true) {
          this.mappedData = mappedData;

        }

        try {
          this.selectedGrade = mappedData[mappedData.length - 1];
          this.getSectionByGrade(this.selectedGrade);
          this.selectedSection = this.selectedGrade.Sections[0];
          this.getSubjects();
        } catch (error) {
          //window.location.reload();
        }

        this.students = [];
        this.NumberOfStudents = [];
        this.SemesterData = [];
        this.TestData = [];
        this.studentRCData = [];
        try {
          this.nameofsec = this.selectedSection.sectionName;
          this.sectionId = this.selectedSection.SectionId;
        } catch (error) {

        }

        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        /*else {
          this.mappedData = mappedData;
          this.get_userdetailes();
        }*/
      },
      error => {
        this.mappedData = [];
        this.sectionList = [];
        this.subjectsList = [];
        this.selectedGrade = null;
        this.selectedSection = null;
        this.selectedSubject = null;
      });
  };


  private getClassSection() {
    this.dataAnalyticsService.getClassSectionMap().finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (this.adminUserFlag) {
          this.mappedData = mappedData;
          // this.priorityFlag = true;
        }
        else {
          this.mappedData = mappedData;
          this.get_userdetailes();
        }
      },
      error => {
      });
  };


  getSectionByGrade(grade) {
    this.subjectsList = [];
    this.papersList = [];
    this.agg_syllabus_list = [];
    this.agg_question_list = [];
    this.syllabusList = [];
    this.selectedSubject = null;
    this.sectionList = grade.Sections;
    this.sectionList.sort((a, b) => {
      if (a.sectionName.toLowerCase() < b.sectionName.toLowerCase()) {
        return -1;
      }
      if (a.sectionName.toLowerCase() > b.sectionName.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    try {
      this.selectedSection = this.sectionList[0];
      this.getSubjects();
    } catch (error) {

    }
  }


  getGclClassesListById(section) {
    this.students = [];
    this.NumberOfStudents = [];
    this.SemesterData = [];
    this.TestData = [];
    this.studentRCData = [];
    this.nameofsec = section.sectionName;
    this.sectionId = section.SectionId;
    this.nameofstudent = [];
    //this.getStudentData(this.standardId,section.SectionId,this.yearId)
    console.log('getGclClassesListById', section);
    this.getSubjects();
  }
  // (minutes >= 1 && minutes <= 15)



  getYearListFrom(year) {
    this.yearIdFrom = year.YearId;
    this.yearnameFrom = year.AcademicYear;
    if (this.yearIdFrom && this.yearIdTo && this.selectedGrade.standardId && this.selectedSubject.SubjectId) {
      if (this.useSyllabus){
        this.getSyllabusData();

      }else{
        this.getPaperData();
      }
    }

    // console.log(this.yearnameFrom)
    // console.log(this.yearIdFrom)
  }


  getYearListTo(year) {
    // console.log(year)
    this.yearIdTo = year.YearId;
    this.yearnameTo = year.AcademicYear;
    if (this.yearIdFrom && this.yearIdTo && this.selectedGrade.standardId && this.selectedSubject.SubjectId) {
      if (this.useSyllabus){
        this.getSyllabusData();

      }else{
        this.getPaperData();
      }
    }
  }

  //
  // private getSemesterData() {
  //   this.dataAnalyticsService.getSemester(this.yearId)._finally(() => { }).subscribe(
  //     response => {
  //       this.SemesterData = response['semestersList'];
  //       console.log("Semesters",this.SemesterData )
  //       // console.log("academicYearId", academicYearId )
  //
  //       try {
  //         this.selectedSemester = this.SemesterData[0];
  //         this.getTestData(this.selectedSemester.SemesterId);
  //       } catch (error) {
  //
  //       }
  //     }
  //   )
  // }
  //


  ////////////----------------------------------///////////////////////////----------------////////////////////----////////////////////

  private getYearData() {
    this.dataAnalyticsService.getYear()._finally(() => { }).subscribe(
      response => {
        this.YearData = response['yearList'];
        // console.log(this.YearData);
        this.yearIdFrom = this.YearData[0].YearId;
        // this.yearName = this.YearData[0].;
        this.yearIdTo = this.YearData[0].YearId;
        // console.log(this.yearIdFrom);
        try {
          this.selectedYearFrom = this.YearData[0];
          this.selectedYearTo = this.YearData[0];
        } catch (error) {

        }

        // console.log(response )
      }
    )
  }


  private getLevelsName() {
    this.dataAnalyticsService
      .getLevel()
      ._finally(() => {})
      .subscribe((response) => {
        this.ShowLevelData = response;
        try {
          this.selectedlevel =  this.ShowLevelData[0].Id;
          //this.getClassSection(this.selectedlevel["Id"]);
          this.getLevelClassSection(this.selectedlevel);

        } catch (error) {

        }
        console.log("ShowLevelData", this.ShowLevelData);
      }, (error) => {

      });
  }

  getLevelsListById(){
    this.papersList = [];
    this.syllabusList = [];
    this.agg_syllabus_list = [];
    this.agg_question_list = [];
    this.getLevelClassSection(this.selectedlevel);
    if (this.yearIdFrom && this.yearIdTo && this.selectedGrade.standardId && this.selectedSubject.SubjectId) {
      if (this.useSyllabus){
        this.getSyllabusData();

      }else{
        this.getPaperData();
      }
    }
  }

////////////----------------------------------///////////////////////////----------------////////////////////----////////////////////
  private GetGrade(){
    this.dataAnalyticsService.getGradeLevel(this.selectedlevel).finally(() => { }).subscribe(
      response => {
        this.grade = response;
        try {
          this.selectedgrade =  this.grade[0].standardId;
        } catch (error) {
        }
        console.log('grade',this.grade)
      },
      error => {
        this.grade = [];
        console.error(error);
        console.log('grade',this.grade)
      });
  };

  changegrade() {
    console.log(this.selectedgrade)

  };
  changesection(){
    console.log(this.selectedsection)
  }

////////////----------------------------------///////////////////////////----------------////////////////////----////////////////////
  queryInput: any;

  onSelectedQuestionCount(value: number) {
    console.log('Selected Question Count:', value);
    // Additional logic here
  }

  toggleMcq(event: any) {
    if (event.target.checked) {
      this.mcq = true;
    } else {
      // Remove the subject from the array if it's unchecked
      this.mcq = false;
    }
    console.log('mcq',this.mcq);
  }


  toggleDiscussion(event: any) {
    if (event.target.checked) {
      this.discussion = true;
    } else {
      // Remove the subject from the array if it's unchecked
      this.discussion = false;
    }
    console.log('discussion',this.discussion);
  }


  toggleShortAnswer(event: any) {
    if (event.target.checked) {
      this.shortAnswer = true;
    } else {
      // Remove the subject from the array if it's unchecked
      this.shortAnswer = false;
    }
    console.log('short answer',this.shortAnswer);
  }


  generate() {
    this.contextQuestions = [];
    this.mcqQuestions = [];
    this.contextQuestionsS = [];
    this.mcqQuestionsS = [];
    if (this.useSyllabus) {
      console.log('syllabus');
      // this.getSyllabusData();

      if (this.agg_syllabus_list.length === 0) {
        this.showErrorDialog("You don't have uploaded syllabus on this subject");
      }
      else {
        let payload: any = {
          agg_sylb_list: this.agg_syllabus_list,
          no_questions: this.selectedQuestionCount,
          subject: this.selectedSubject.SubjectName,
          year: this.YearData[0].AcademicYear
        };

        console.log(payload);
        const apiCode = 'U52kDwFUJU8dyKxF_9yBdyzWHdIRHbPy1svJRQzTQz45AzFu2nrr0w==';
        this.isLoading = true;
        this.dataAnalyticsService.generatePaperBySyllabus(payload, apiCode).subscribe({
          next: (response) => {
            console.log(response);
            this.contextQuestionsS = response['context_ques'];
            this.mcqQuestionsS = response['mcq_ques'];
            console.log(this.contextQuestionsS);
            this.isLoading = false;
          },
          error: (error) => {
            console.error(error);
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: "Question generation failed"
            });
            this.isLoading = false;
          }
        });
      }
    } else {
      console.log('no syllabus');
      // this.getPaperData();
      if (this.agg_question_list.length === 0) {
        this.showErrorDialog("You don't have uploaded papers on this subject");
      }else if(!this.mcq && !this.shortAnswer){
        let payload: any = {
          agg_question_list: this.agg_question_list,
          no_questions: this.selectedQuestionCount,
          mcq: "True", // Convert boolean to string
          short: "True", // Convert boolean to string
          subject: this.selectedSubject.SubjectName,
          user_special_query: this.queryInput,
        };
        console.log(payload);
        const apiCode = 'VSoK9Ip_yY3TdbG5Z1KkYoLAmkelybWP4tcuwxy4BFgLAzFuq5I54Q==';

        const timeoutId = setTimeout(() => {
          this.isLoading = false;
          this.messageService.add({
            severity: "error",
            summary: "Timeout",
            detail: "Sorry, please try again"
          });
        }, 60000); // 1 minute timeout
        this.isLoading = true;
        this.dataAnalyticsService.generatePaperByPapers(payload, apiCode).subscribe({
          next: (response) => {
            clearTimeout(timeoutId); // Clear the timeout on successful response
            this.contextQuestions = response['context_ques'];
            this.mcqQuestions = response['mcq_ques'];
            console.log(this.contextQuestions);
            console.log(this.mcqQuestions);
            this.isLoading = false;
          },
          error: (error) => {
            console.error(error);
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: "Question generation failed"
            });
            this.isLoading = false;
          }
        });
      } else {
        let payload: any = {
          agg_question_list: this.agg_question_list,
          no_questions: this.selectedQuestionCount,
          mcq: this.mcq ? "True" : "False", // Convert boolean to string
          short: this.shortAnswer ? "True" : "False", // Convert boolean to string
          subject: this.selectedSubject.SubjectName,
          user_special_query: this.queryInput,
        };

        console.log(payload);
        const apiCode = 'VSoK9Ip_yY3TdbG5Z1KkYoLAmkelybWP4tcuwxy4BFgLAzFuq5I54Q==';

        const timeoutId = setTimeout(() => {
          this.isLoading = false;
          this.messageService.add({
            severity: "error",
            summary: "Timeout",
            detail: "Sorry, please try again"
          });
        }, 60000); // 1 minute timeout
        this.isLoading = true;
        this.dataAnalyticsService.generatePaperByPapers(payload, apiCode).subscribe({
          next: (response) => {
            clearTimeout(timeoutId); // Clear the timeout on successful response
            this.contextQuestions = response['context_ques'];
            this.mcqQuestions = response['mcq_ques'];
            console.log(this.contextQuestions);
            console.log(this.mcqQuestions);
            this.isLoading = false;
          },
          error: (error) => {
            console.error(error);
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: "Question generation failed"
            });
            this.isLoading = false;
          }
        });
      }
    }
    // this.isLoading = false;
  }



  showErrorDialog(message: string) {
    this.errorMessage = message;
    this.displayErrorDialog = true;
    this.isLoading = false;
    this.isSuccessful = 2;
  }

  private getPaperData() {
    this.isLoading = true; // Start loading
    this.dataAnalyticsService.getPaper(this.yearIdFrom,this.yearIdTo,this.selectedGrade.standardId,this.selectedSubject.SubjectId)._finally(() => {
      this.isLoading = false; // Stop loading
    }).subscribe(
      response => {
        console.log(response);
        this.papersList = response['Values'];
        // Mapping the response to a new array containing only the specified properties
        this.agg_question_list = this.papersList.map(item => ({
          question_list: JSON.parse(item.Content),
          year: item.AcademicYearName,
          grade: item.GradeName,
          source: item.PaperName,
          Term: item.SemesterName,
          subject_type: item.SubjectName,
        }));

        console.log(this.agg_question_list);
      },
      error => {
        this.isLoading = false; // Start loading
        console.error(error);
        this.showErrorDialog("You don't have uploaded papers on this subject");
      }
    )
  }





  private getSyllabusData() {
    this.isLoading = true; // Start loading
    this.dataAnalyticsService.getSyllabusGenerate(this.yearIdFrom,this.yearIdTo,this.selectedGrade.standardId,this.selectedSubject.SubjectId)._finally(() => {
      this.isLoading = false; // Stop loading
    }).subscribe(
      response => {
        console.log(response);
        this.syllabusList = response['Values'];
        // Mapping the response to a new array containing only the specified properties
        this.agg_syllabus_list = this.syllabusList.map(item => ({
          syllabus_list: JSON.parse(item.Content),
          year: item.AcademicYearName,
          grade: item.GradeName,
          source: item.PaperName,
          Term: item.SemesterName,
          subject_type: item.SubjectName,
        }));

        console.log(this.agg_syllabus_list);
      },
      error => {
        this.isLoading = false; // Start loading
        console.error(error);
        this.showErrorDialog("You don't have uploaded syllabus on this subject");
      }
    )
  }






  PrintPdf() {

    const options = {
      filename: this.selectedGrade.standardsName+'_'+this.selectedSubject.SubjectName,
      margin: [15, 0, 15, 0],
      image: { type: 'jpeg', quality: 1 },
      // html2canvas : {},
      layout: 'noBorders',
      html2canvas: {
        dpi: 192,
        scale: 4,
        letterRendering: true,
        useCORS: true,
        // allowTaint : true
      },
      jsPDF: { orientation: 'portrait', unit: 'pt', format: 'a4', compressPDF: false }
    };

    const content: Element = document.getElementById('asdf')

    html2pdf()
      .from(content)
      .set(options)
      .save();
  }


  PrintPdff() {

    const options = {
      filename: this.selectedGrade.standardsName+'_'+this.selectedSubject.SubjectName,
      margin: [15, 0, 15, 0],
      image: { type: 'jpeg', quality: 1 },
      // html2canvas : {},
      layout: 'noBorders',
      html2canvas: {
        dpi: 192,
        scale: 4,
        letterRendering: true,
        useCORS: true,
        // allowTaint : true
      },
      jsPDF: { orientation: 'portrait', unit: 'pt', format: 'a4', compressPDF: false }
    };

    const content: Element = document.getElementById('asdff')

    html2pdf()
      .from(content)
      .set(options)
      .save();
  }



  savePdf() {
    this.isLoading = true;
    // this.showSaveDialog = true;
    if (this.pdfName) {
      // Add your PDF saving logic here
     let questions: any;
      // console.log(this.contextQuestionsS);
      // console.log(this.mcqQuestionsS);
      // console.log(this.contextQuestions);
      // console.log(this.mcqQuestions);

      if (this.useSyllabus){
        questions = {
          'contextQuestions': this.contextQuestionsS,
          'mcqQuestions': this.mcqQuestionsS,
        }
      }else{
        questions = {
          'contextQuestions': this.contextQuestions,
          'mcqQuestions': this.mcqQuestions,
        }
      }

      console.log(questions);
      console.log(this.useSyllabus);

      const contentJSONString = JSON.stringify(questions);

      let payload: any = {
        PaperName: this.pdfName,
        AcademicYearFromId: this.yearIdFrom,
        AcademicYearToId: this.yearIdTo,
        GradeId: this.selectedGrade.standardId,
        SubjectId: this.selectedSubject.SubjectId,
        SemesterId: 0,
        ExamId: 0,
        UploadedBy: '',
        Content: contentJSONString,
        PDFContent: '',
      };
      console.log(payload);
      this.dataAnalyticsService.UploadGeneratedPapers(payload).finally(() => {
      }).subscribe(
        response => {
          let res: any = response;
          console.log("upload", res);
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: "PDF File uploaded successfully",
          });
          this.showSaveDialog = false;
          this.isLoading = false;
        },
        error => {
          console.log("UploadCSVFile error", error);
          this.messageService.add({
            severity: "error",
            summary: "Talkative Parents",
            detail: "Paper saving failed",
          });
          this.showSaveDialog = false;
          this.isLoading = false;
        });
      this.showSaveDialog = false;
      this.pdfName = ''; // Reset the name
    }
  }

  generateAnswers() {

  }


  // In your component.ts
  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  close() {
    this.showSaveDialog = false;
  }

  save() {
    this.showSaveDialog = true;
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/quonta-intelligence/my-notes/my-notes.component.ts